import { __assign, __rest } from "tslib";
import React from 'react';
export var Heart = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: size, height: size }, rest),
        React.createElement("path", { d: "M12,20.8623a2.75115,2.75115,0,0,1-1.94922-.80468L3.83691,13.84277A6.27238,6.27238,0,0,1,12,4.36328a6.27239,6.27239,0,0,1,8.16309,9.47949l-6.21338,6.21387A2.75,2.75,0,0,1,12,20.8623Z" })));
};
//# sourceMappingURL=Heart.js.map